/**
 * Manifiesto frontend — Expedientes de operaciones (materialidad / soporte documental).
 * Licencia comercial: reutiliza entitlement «tramites» (mismo plan que Trámites Fiscales).
 * Visibilidad comprador: independiente (buyer_module_visibility.materialidad).
 */
export const MODULO_MATERIALIDAD_ID = "materialidad";

export const MATERIALIDAD_CONTEXT_LABEL = "Expedientes de operaciones";

export const MODULO_MATERIALIDAD_CARD = {
  id: MODULO_MATERIALIDAD_ID,
  title: "Expedientes de operaciones",
  description:
    "Soporte documental: revisión del despacho, portal de clientes, detección CFDI, riesgos EFOS/opinión y exportación PDF.",
  bullets: [
    "Revisión del despacho: lista de verificación por empresa, periodo y auxiliar",
    "Detección CFDI (PPD, cancelados, proveedor nuevo)",
    "Riesgos EFOS / opinión de cumplimiento",
    "Exportación de expediente PDF",
  ],
  entryPath: "/materialidad/expediente",
  path: "/materialidad/expediente",
  route: "/materialidad/expediente",
};

export const MATERIALIDAD_EXPEDIENTE_PATH = "/materialidad/expediente";
export const MATERIALIDAD_INICIO_PATH = "/materialidad/inicio";

/** Paths propios del módulo (Layout sync + guards). */
export const MATERIALIDAD_MODULE_PATHS = new Set([
  MATERIALIDAD_INICIO_PATH,
  MATERIALIDAD_EXPEDIENTE_PATH,
]);

export const MATERIALIDAD_TAB_CONFIG = [
  {
    id: "expediente",
    path: MATERIALIDAD_EXPEDIENTE_PATH,
    label: "Expediente documental",
    title: "Expedientes de operaciones",
    description:
      "Soporte documental: revisión del despacho, portal de clientes, detección CFDI, riesgos EFOS/opinión y exportación PDF.",
    iconKey: "folder",
    testid: "materialidad-hub-expediente",
  },
];

export function getMaterialidadFeatureCards() {
  return MATERIALIDAD_TAB_CONFIG.map((tab) => ({
    path: tab.path,
    label: tab.title || tab.label,
    description: tab.description,
    iconKey: tab.iconKey,
    testid: tab.testid,
  }));
}
